import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {AttachmentModel, AttachmentVisualContentTypesEnum} from '../../../../../models/api/attachmentModel';
import {CommentAttachment} from '../attachments/commentAttachment';

/*
 * Props.
 */

interface CommentViewerAttachmentsProps {
  attachments: ReadonlyArray<AttachmentModel>;
  newMultiAttachmentStyle: boolean;
  isInteractionDisabled?: boolean;
  isAttachmentsBelowText?: boolean;
  isCommentMarginDisabled?: boolean;
}

interface CommentAttachmentsStyleProps {
  $isAttachmentsBelowText: boolean;
  $isCommentMarginDisabled: boolean;
}

interface CommentAttachmentStyleProps {
  $isCommentMarginDisabled: boolean;
  $isAttachmentMaxWidthRequired: boolean;
}

/*
 * Styles.
 */

const StyledCommentViewerAttachmentsDiv = styled.div<CommentAttachmentsStyleProps>`
  display: grid;
  margin: 12px;

  ${(p) =>
    p.$isAttachmentsBelowText &&
    css`
      margin-top: 4px;
    `}
  ${(p) =>
    p.$isCommentMarginDisabled &&
    css`
      margin: 0;
    `}
`;

const StyledCommentAttachmentDiv = styled.div<CommentAttachmentStyleProps>`
  ${(p) =>
    p.$isAttachmentMaxWidthRequired &&
    css`
      max-width: 160px;
    `}
  &:not(:first-child) {
    margin-top: ${(p) => (p.$isCommentMarginDisabled ? '0' : '4')}px;
  }
  &:not(:last-child) {
    margin-bottom: ${(p) => (p.$isCommentMarginDisabled ? '0' : '4')}px;
  }
`;

/*
 * Component.
 */

export const CommentViewerAttachments: FC<CommentViewerAttachmentsProps> = (props) => {
  const {
    attachments,
    newMultiAttachmentStyle,
    isAttachmentsBelowText,
    isCommentMarginDisabled,
    isInteractionDisabled,
  } = props;

  if (attachments.length === 0) {
    return null;
  }

  // Render every attachment.
  const attachmentRenders = attachments.map((a) => (
    <StyledCommentAttachmentDiv
      key={a.cid}
      $isCommentMarginDisabled={Boolean(isCommentMarginDisabled)}
      $isAttachmentMaxWidthRequired={a.visualContentType !== AttachmentVisualContentTypesEnum.IMAGE}
    >
      <CommentAttachment
        attachment={a}
        newMultiAttachmentStyle={newMultiAttachmentStyle}
        isInteractionDisabled={isInteractionDisabled}
      />
    </StyledCommentAttachmentDiv>
  ));
  return (
    <StyledCommentViewerAttachmentsDiv
      $isAttachmentsBelowText={Boolean(isAttachmentsBelowText)}
      $isCommentMarginDisabled={Boolean(isCommentMarginDisabled)}
    >
      {attachmentRenders}
    </StyledCommentViewerAttachmentsDiv>
  );
};
